import { render } from "./BoqSectionRow.vue?vue&type=template&id=79d7b53e&scoped=true"
import script from "./BoqSectionRow.vue?vue&type=script&lang=js"
export * from "./BoqSectionRow.vue?vue&type=script&lang=js"

import "./BoqSectionRow.vue?vue&type=style&index=0&id=79d7b53e&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79d7b53e"]])

export default __exports__